var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0934 93.7907C29.0934 93.7907 79.9585 77.2113 139.918 97.9758C139.999 97.9758 91.3871 87.9155 29.0934 93.7907Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 82.6036H22.7364L24.2656 67.0704L31.1871 82.8451H31.7505L38.833 66.829L40.1207 82.7646H46.3179L44.1449 62.0805H37.8672L33.3602 73.0262L28.5312 62H20.3219V62.7243C20.3219 62.7243 22.2535 62.4829 22.0121 65.0583L20 82.6036Z",
    fill: "#1E2171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1678 63.9316V64.5755C48.1678 64.5755 50.019 64.4145 50.019 66.9095C50.019 69.4045 50.019 82.8451 50.019 82.8451H55.4113V63.9316H48.1678Z",
    fill: "#1E2171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.31 63.8511V67.7947H58.8733C58.8733 67.7947 58.7124 66.2656 60.8854 66.2656H67.1631L57.8271 82.1207V82.845H75.2918V80.4305H65.151L74.7284 64.4949V63.8511H58.31Z",
    fill: "#1E2171"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5331 63.8511H82.6961V77.2917C82.6961 77.2917 82.2937 80.9134 86.3983 80.9134H89.6982V66.8289C89.6982 66.8289 90.1006 64.7364 88.008 64.7364V63.9316H95.332V72.0603H102.334V66.346C102.334 66.346 102.656 64.5754 100.563 64.5754V63.9316H107.807V82.6036H102.173C102.173 82.6036 102.414 80.7525 102.414 79.6257V74.0724H95.0905V80.0281C95.0905 80.0281 95.01 81.2354 95.2515 82.5231C95.2515 82.5231 89.9396 83.006 86.5593 83.006C83.179 83.006 77.2233 83.0865 77.2233 75.843C77.2233 68.5191 77.2233 67.3118 77.2233 67.3118C77.2233 67.3118 77.4647 64.5754 75.6136 64.5754V63.8511H75.5331Z",
    fill: "#1E2171"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.603 63.4487C114.486 63.4487 109.577 67.7948 109.577 73.1067C109.577 78.4185 114.486 82.7646 120.603 82.7646C126.72 82.7646 131.629 78.4185 131.629 73.1067C131.71 67.7948 126.72 63.4487 120.603 63.4487ZM120.684 80.9135C117.625 80.9135 115.13 77.5332 115.13 73.3481C115.13 69.163 117.625 65.7827 120.684 65.7827C123.742 65.7827 126.237 69.163 126.237 73.3481C126.237 77.5332 123.742 80.9135 120.684 80.9135Z",
    fill: "#1E2171"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.5842,
    y1: 92.742,
    x2: 76.3391,
    y2: 92.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31B23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 35.9759,
    fill: "white",
    transform: "translate(20 62)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMb);
export default __webpack_public_path__ + "static/media/mb.e80eaf73.svg";
export { ForwardRef as ReactComponent };